import { Inject, Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SignalRConnection } from '../models/signalr.model';
import { SubscribeResponse, Conversation, Message, UxItem, Attachment } from '../models/chatstyle.model';
import { environment } from '../../../environments/environment';
import { AppConfigService } from '../../shared/appconfig/appconfig.service';

import { HubConnection } from '@microsoft/signalr';
import * as SignalR from '@microsoft/signalr';

@Injectable()
export class SignalRDebugService {

  constructor(private http: HttpClient) {
  }

  private hubConnection: HubConnection;
  public DebugMessageReceived: EventEmitter<DebugMessage> = new EventEmitter<DebugMessage>();
  public Subscribed: EventEmitter<SubscribeResponse> = new EventEmitter<SubscribeResponse>();

  private get url(): string {
    return AppConfigService.settings?.get('signalrServer') || environment.signalrServer.url;
  }
  private userId: string;
  private botId: string;
  private conversationId: string;
  private headers: HttpHeaders;


  init(id, bot, conversation): Promise<void> {

    const sessionKey = conversation || `${id}-${Date.now()}`;
    this.userId = 'debug-' + sessionKey;
    this.botId = bot;
    this.conversationId = conversation;

    this.headers = new HttpHeaders().set('x-ms-signalr-userid', this.userId);
    if (conversation) {
      this.headers = this.headers.set('cv', this.conversationId);
    }

    this.stopConnection();

    return new Promise<void>((resolve, reject) => {
      this.getSignalRConnection().subscribe(con => {

        const options = {
          accessTokenFactory: () => con.accessToken
        };

        this.hubConnection = new SignalR.HubConnectionBuilder()
          .withUrl(con.url, options)
          .configureLogging(SignalR.LogLevel.Information)
          .build();

        this.hubConnection.on('debugRelay', data => {
          const incomingConversationID = data.Conversation?.ConversationID ?? data.Message?.ConversationID;
          if (!incomingConversationID) return;
          console.log('[DebugService] debugRelay received, incoming:', incomingConversationID, 'expected:', this.conversationId);
          if (this.conversationId === incomingConversationID) {
            console.log('[DebugService] match — emitting', data);
            const cv: Conversation = {
              botID: data.Conversation?.BotID,
              conversationID: incomingConversationID,
              active: data.Conversation?.Active,
              status: data.Conversation?.Status,
              state: data.Conversation?.State,
              audienceChannelID: data.Conversation?.audienceChannelID,
              message: null
            };
            if (data.Message) {
              const message: Message = {
                conversationID: data.Conversation?.ConversationID ?? incomingConversationID,
                channel: data.Message.Channel,
                recipientID: data.Message.RecipientID,
                senderID: data.Message.SenderID,
                text: data.Message.Text,
                body: data.Message.Body,
                time: data.Message.Time,
                payload: data.Message.Payload,
                uxItems: [],
                attachments: [],
                fromDisplayName: '',
                toDisplayName: '',
                tag: '',
                info: '',
                blockInput: false,
                blockAttachments: false,
                ttl: ''
              };
              cv.message = message;
            }
            const msg: DebugMessage = {
              type: data.Type,
              conversation: cv
            };
            this.DebugMessageReceived.emit(msg);
          }
        });

        this.hubConnection.start()
          .then(() => {
            console.log('[DebugService] hub connected, userId:', this.userId);
            this.http.post<SubscribeResponse>(this.url + '/subscribe?botId=' + this.botId, '', { headers: this.headers })
              .subscribe({
                next: result => {
                  console.log('[DebugService] subscribed, conversationID:', result.conversationID, 'cv header:', this.conversationId);
                  if (!this.conversationId) {
                    this.conversationId = result.conversationID;
                  }
                  this.Subscribed.emit(result);
                  resolve();
                },
                error: err => {
                  console.error('[DebugService] subscribe failed', err);
                  reject(err);
                }
              });
          })
          .catch(error => {
            console.error('[DebugService] hub connect failed', error);
            reject(error);
          });

      }, error => reject(error));
    });
  }

  stopConnection() {
    if (this.hubConnection) {
      this.hubConnection.stop();
      this.hubConnection = null;
    }
  }

  private getSignalRConnection(): Observable<SignalRConnection> {
    return this.http.post<SignalRConnection>(
      this.url + '/negotiate', {}, { headers: this.headers }
    );
  }

}

export interface DebugMessage {
  type: string;
  conversation: Conversation;
};
